export default function Django_Add_Global_Static_Files() {
  return <div>Django_Add_Global_Static_Files Component</div>;
}
